module.exports = __webpack_public_path__ + "static/media/ios-pricetags.fd93312d.svg";